let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kefuj")).then(() => parcelRequire('d92Sa'));